export default __webpack_public_path__ + "static/media/img3.c3ca3efd.webp";